/**
 * @name square-bottom-dashed-scissors
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMjFoMSIgLz4KICA8cGF0aCBkPSJtMTcgMTctMi4xOC0yLjE4IiAvPgogIDxwYXRoIGQ9Ik01IDIxYTIgMiAwIDAxLTItMlY1YTIgMiAwIDAxMi0yaDE0YTIgMiAwIDAxMiAydjE0YTIgMiAwIDAxLTIgMiIgLz4KICA8cGF0aCBkPSJNOSAyMWgxIiAvPgogIDxwYXRoIGQ9Ik05LjU2IDE0LjQ0IDE3IDciIC8+CiAgPHBhdGggZD0iTTkuNTYgOS41NiAxMiAxMiIgLz4KICA8Y2lyY2xlIGN4PSI4LjUiIGN5PSIxNS41IiByPSIxLjUiIC8+CiAgPGNpcmNsZSBjeD0iOC41IiBjeT0iOC41IiByPSIxLjUiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/square-bottom-dashed-scissors
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const SquareBottomDashedScissors: string = `
<svg
  class="lucide lucide-square-bottom-dashed-scissors"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M14 21h1" />
  <path d="m17 17-2.18-2.18" />
  <path d="M5 21a2 2 0 01-2-2V5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2" />
  <path d="M9 21h1" />
  <path d="M9.56 14.44 17 7" />
  <path d="M9.56 9.56 12 12" />
  <circle cx="8.5" cy="15.5" r="1.5" />
  <circle cx="8.5" cy="8.5" r="1.5" />
</svg>
`;

export default SquareBottomDashedScissors;
